<script setup>
    import { onMounted, onUnmounted, ref } from 'vue'
    import {clamp, debounce} from "lodash";

    const props = defineProps({
        headLines: Object,
        link: String,
        linkLabel: String
    })

    const element = ref(null),
          percentInView = ref(0)

    onMounted(() => {
        const observer = new IntersectionObserver(([entry]) => {
            entry.isIntersecting ? startScrollListener() : stopScrollListener();
        })
        observer.observe(element.value)
    })

    onUnmounted(() => {
        stopScrollListener()
    })

    function startScrollListener() {
        window.addEventListener('scroll', handleScroll)
    }

    function stopScrollListener() {
        window.removeEventListener('scroll', handleScroll)
    }

    function handleScroll() {
        const elementRect = element.value.getBoundingClientRect(),
              windowHeight = window.innerHeight

        if (!window?.reduced_motion) {
            percentInView.value = Math.max(0, Math.min(1, (windowHeight - elementRect.top) / (windowHeight + elementRect.height)))
        }
    }
</script>
<template>
    <div ref="element" class="w-full bg-white overflow-hidden my-14 lg:my-20">
        <div class="inner flex flex-col items-center justify-center subpixel-antialiased">
            <template v-for="( line, index ) in headLines">
                <span
                    v-if="index % 2 === 0" :key="index"
                    aria-hidden="true"
                    class="block text-[10vw] md:text-[6vw] leading-tight whitespace-nowrap m-0"
                    style="color: white; background-color: white; text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;"
                    :style="{ transform: `translate3d(${percentInView * 25}%, 0, 0)` }"
                >
                    {{ line.head_line }}
                </span>
                <h3
                    v-else
                    class="text-[10vw] md:text-[6vw] leading-tight whitespace-nowrap m-0 transition-colors duration-300 text-black hover:text-cintra-orange"
                    :style="{ transform: `translate3d(-${percentInView * 25}%, 0, 0)` }"
                >
                    {{ line.head_line }}
                </h3>
            </template>
            <div v-if="props.link && props.linkLabel" class="w-full text-center pt-20">
                <a :href="props.link" class="theme-button">{{ props.linkLabel }}</a>
            </div>
        </div>
    </div>
</template>
